import { css } from '@emotion/css'
import {
  colors,
  shorthandHelper,
  fontWeight,
  spacing,
  textStyles,
  mediaQueryHelper,
  breakpoint,
} from '@offerzen/pinata'

const styles = {
  modalBody: css({
    p: {
      ...textStyles,
      color: colors.blackPearl,
      margin: shorthandHelper([0, 0, spacing.default]),
    },
  }),

  semiBold: css({
    fontWeight: fontWeight.semiBold,
  }),

  footer: css({
    padding: spacing.medium,
    marginTop: 0,
    borderTop: `solid 1px ${colors.geyser}`,

    '> a': {
      alignSelf: 'center',
    },

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      flexDirection: 'column',
      '> a': {
        margin: shorthandHelper([spacing.large, 0, 0]),
      },
    },
  }),
}

export default styles
